export const MOCK_LEADERBOARD = {
  totalParticipants: 250,
  rows: [
    {
      rank: 10,
      displayName: "Cole Silva",
      initials: "CS",
      learningCompleted: 46,
      badgesEarned: 43,
      isCurrentUser: false,
    },
    {
      rank: 11,
      displayName: "Sofia Hassan",
      initials: "SH",
      learningCompleted: 45,
      badgesEarned: 44,
      isCurrentUser: false,
    },
    {
      rank: 12,
      displayName: "You",
      initials: "MT",
      learningCompleted: 41,
      badgesEarned: 41,
      isCurrentUser: true,
    },
    {
      rank: 13,
      displayName: "Carlos Garcia",
      initials: "CG",
      learningCompleted: 40,
      badgesEarned: 40,
      isCurrentUser: false,
    },
  ],
};
